import React from 'react';

export function Envelope(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="550.795"
      height="550.795"
      x="0"
      y="0"
      enableBackground="new 0 0 550.795 550.795"
      version="1.1"
      viewBox="0 0 550.795 550.795"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M501.613 491.782c12.381 0 23.109-4.088 32.229-12.16L377.793 323.567a2878.213 2878.213 0 00-10.801 7.767c-11.678 8.604-21.156 15.318-28.434 20.129-7.277 4.822-16.959 9.737-29.045 14.755-12.094 5.024-23.361 7.528-33.813 7.528h-.612c-10.453 0-21.72-2.503-33.813-7.528-12.093-5.018-21.775-9.933-29.045-14.755-7.277-4.811-16.75-11.524-28.434-20.129a1351.934 1351.934 0 00-10.771-7.809L16.946 479.622c9.119 8.072 19.854 12.16 32.234 12.16h452.433zM31.047 225.299C19.37 217.514 9.015 208.598 0 198.555V435.98l137.541-137.541c-27.516-19.21-62.969-43.562-106.494-73.14zM520.059 225.299c-41.865 28.336-77.447 52.73-106.75 73.195l137.486 137.492V198.555c-8.815 9.841-19.059 18.751-30.736 26.744z"></path>
      <path d="M501.613 59.013H49.181c-15.784 0-27.919 5.33-36.42 15.979C4.253 85.646.006 98.97.006 114.949c0 12.907 5.636 26.892 16.903 41.959 11.267 15.061 23.256 26.891 35.961 35.496 6.965 4.921 27.969 19.523 63.012 43.801a20367.497 20367.497 0 0149.505 34.395 8855.122 8855.122 0 0131.022 21.701c.985.691 2.534 1.799 4.59 3.269 2.215 1.591 5.018 3.61 8.476 6.107 6.659 4.816 12.191 8.709 16.597 11.683 4.4 2.975 9.731 6.298 15.985 9.988 6.249 3.685 12.143 6.456 17.675 8.299 5.533 1.842 10.655 2.766 15.367 2.766h.612c4.711 0 9.834-.924 15.368-2.766 5.531-1.843 11.42-4.608 17.674-8.299 6.248-3.69 11.572-7.02 15.986-9.988 4.406-2.974 9.938-6.866 16.598-11.683 3.451-2.497 6.254-4.517 8.469-6.102a643.575 643.575 0 014.596-3.274c6.684-4.651 17.1-11.892 31.104-21.616 25.482-17.705 63.01-43.764 112.742-78.281 14.957-10.447 27.453-23.054 37.496-37.803 10.025-14.749 15.051-30.22 15.051-46.408 0-13.525-4.873-25.098-14.598-34.737-9.736-9.627-21.265-14.443-34.584-14.443z"></path>
    </svg>
  );
}

export function Calendar(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
  );
}

export function Phone(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="348.077"
      height="348.077"
      x="0"
      y="0"
      enableBackground="new 0 0 348.077 348.077"
      version="1.1"
      viewBox="0 0 348.077 348.077"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M340.273 275.083l-53.755-53.761c-10.707-10.664-28.438-10.34-39.518.744l-27.082 27.076a792.327 792.327 0 01-5.344-2.973c-17.102-9.476-40.509-22.464-65.14-47.113-24.704-24.701-37.704-48.144-47.209-65.257-1.003-1.813-1.964-3.561-2.913-5.221l18.176-18.149 8.936-8.947c11.097-11.1 11.403-28.826.721-39.521L73.39 8.194c-10.682-10.68-28.421-10.356-39.518.744l-15.15 15.237.414.411c-5.08 6.482-9.325 13.958-12.484 22.02C3.74 54.28 1.927 61.603 1.098 68.941-6 127.785 20.89 181.564 93.866 254.541c100.875 100.868 182.167 93.248 185.674 92.876 7.638-.913 14.958-2.738 22.397-5.627 7.992-3.122 15.463-7.361 21.941-12.43l.331.294 15.348-15.029c11.074-11.098 11.393-28.83.716-39.542z"></path>
    </svg>
  );
}

export function ChatBubbles(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.743"
      height="30.744"
      x="0"
      y="0"
      enableBackground="new 0 0 30.743 30.744"
      version="1.1"
      viewBox="0 0 30.743 30.744"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M28.585 9.67h-.842v9.255c0 1.441-.839 2.744-2.521 2.744H8.743v.44c0 1.274 1.449 2.56 2.937 2.56h12.599l4.82 2.834-.699-2.834h.185c1.487 0 2.158-1.283 2.158-2.56V11.867c0-1.274-.671-2.197-2.158-2.197z"></path>
      <path d="M22.762 3.24H3.622C1.938 3.24 0 4.736 0 6.178v11.6c0 1.328 1.642 2.287 3.217 2.435l-1.025 3.891L8.76 20.24h14.002c1.684 0 3.238-1.021 3.238-2.462v-11.6c0-1.442-1.555-2.938-3.238-2.938zm-16.22 9.792a1.729 1.729 0 110-3.458 1.729 1.729 0 010 3.458zm6.458 0a1.729 1.729 0 110-3.458 1.729 1.729 0 010 3.458zm6.459 0a1.73 1.73 0 110-3.46 1.73 1.73 0 010 3.46z"></path>
    </svg>
  );
}

export function Remove(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
  );
}

export function Edit(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
  );
}

export function ExitApp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 00-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
    </svg>
  );
}

export function Eye(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 488.85 488.85"
      version="1.1"
      viewBox="0 0 488.85 488.85"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M244.425 98.725c-93.4 0-178.1 51.1-240.6 134.1-5.1 6.8-5.1 16.3 0 23.1 62.5 83.1 147.2 134.2 240.6 134.2s178.1-51.1 240.6-134.1c5.1-6.8 5.1-16.3 0-23.1-62.5-83.1-147.2-134.2-240.6-134.2zm6.7 248.3c-62 3.9-113.2-47.2-109.3-109.3 3.2-51.2 44.7-92.7 95.9-95.9 62-3.9 113.2 47.2 109.3 109.3-3.3 51.1-44.8 92.6-95.9 95.9zm-3.1-47.4c-33.4 2.1-61-25.4-58.8-58.8 1.7-27.6 24.1-49.9 51.7-51.7 33.4-2.1 61 25.4 58.8 58.8-1.8 27.7-24.2 50-51.7 51.7z"></path>
    </svg>
  );
}

export function House(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M470.735 158.055L305.743 6.62C300.323 2.285 293.849 0 287.023 0c-6.825 0-13.314 2.285-18.733 6.62L103.315 157.603c-12.93 10.326-15.074 29.186-4.688 42.154 10.293 12.89 29.176 15.085 42.154 4.688L287.023 69.461l146.274 135.451c12.073 9.722 32.31 7.625 42.125-4.717 10.371-12.914 8.256-31.803-4.687-42.14zM437.01.044h-59.995c-8.29 0-14.999 6.708-14.999 14.999v2.366l89.992 83.002V15.043C452.009 6.752 445.301.044 437.01.044zM47.044 241.023H15.047c-8.29 0-14.999 6.708-14.999 14.999v240.979c0 8.29 6.708 14.999 14.999 14.999h31.997c24.812 0 44.996-20.184 44.996-44.996V286.019c0-24.812-20.183-44.996-44.996-44.996zM499.706 276.72c-12.3-8.999-29.398-7.199-39.597 3.9l-80.993 100.791c-5.7 5.999-16.499 9.599-22.198 9.599h-129.89c-8.4 0-14.999-6.598-14.999-14.999s6.598-14.999 14.999-14.999h119.99c16.499 0 29.997-13.499 29.997-29.997 0-16.499-13.499-29.997-29.997-29.997h-78.593c-7.475 0-11.203-4.741-17.099-9.9-8.999-8.098-19.198-14.098-29.697-18.298-32.506-13.274-70.067-9.257-99.591 11.275v197.907h224.981c28.198 0 55.196-13.499 71.995-35.997l86.992-126.989c9.898-13.199 7.198-32.397-6.3-42.296z"></path>
      <path d="M286.994 110.312L152.035 234.89v4.07c9.901-2.281 19.993-3.825 30.319-3.825 17.475 0 34.494 3.34 50.606 9.916 3.177 1.271 6.026 3.069 9.066 4.565v-23.591c0-8.29 6.708-14.999 14.999-14.999h59.995c8.29 0 14.999 6.708 14.999 14.999v44.996h15c24.065 0 44.864 14.237 54.414 34.728l20.579-25.609v-44.893L286.994 110.312z"></path>
      <path d="M272.024 241.023L272.024 269.391 273.826 271.021 302.022 271.021 302.022 241.023z"></path>
    </svg>
  );
}

export function UserCheck(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 16.377 16.377"
      version="1.1"
      viewBox="0 0 16.377 16.377"
      xmlSpace="preserve"
      {...props}
    >
      <g fill="#ffffff">
        <path d="M4.331 5.043a.959.959 0 00.238.52c.231 1.54 1.521 2.97 2.698 2.97 1.373 0 2.623-1.547 2.865-2.967a.952.952 0 00.242-.522c.078-.289.18-.791.002-1.025l-.029-.034c.166-.606.377-1.858-.375-2.711-.066-.086-.486-.588-1.387-.854L8.158.271C7.45.052 7.004.004 6.986.001a.284.284 0 00-.096.008.507.507 0 01-.174.021c-.169-.024-.423.063-.468.08-.06.023-1.43.573-1.846 1.849-.039.104-.205.646.016 1.977a.346.346 0 00-.088.083c-.178.234-.078.735.001 1.024zm.538-2.902l.008-.021C5.216 1.068 6.418.582 6.426.578a.81.81 0 01.219-.051c.118.016.254-.005.328-.022.121.017.497.078 1.028.242l.432.148c.801.237 1.141.681 1.143.684l.016.019c.695.783.338 2.079.211 2.457a.25.25 0 00.172.322c.002.123-.033.348-.088.545l-.006.028c-.021.139-.068.24-.131.286a.26.26 0 00-.1.167c-.166 1.19-1.268 2.629-2.382 2.629-.938 0-2.055-1.325-2.213-2.624a.245.245 0 00-.099-.17c-.063-.048-.11-.15-.131-.287a2.414 2.414 0 01-.093-.547.25.25 0 00.226-.298c-.275-1.444-.089-1.965-.089-1.965z"></path>
        <path d="M12.224 9.363c-.738-.487-1.855-.84-1.855-.84-1.121-.396-1.129-.79-1.129-.79-2.203 4.344-3.876.014-3.876.014-.154.586-2.423 1.274-2.423 1.274-.663.254-.943.636-.943.636-.98 1.454-1.096 4.689-1.096 4.689.013.739.332.816.332.816 2.254 1.006 5.792 1.185 5.792 1.185.985.021 1.894-.047 2.701-.154a3.945 3.945 0 01-1.262-2.887 3.953 3.953 0 013.759-3.943z"></path>
        <path d="M12.269 9.963a3.21 3.21 0 00-3.207 3.207 3.21 3.21 0 003.207 3.207 3.209 3.209 0 003.207-3.207 3.21 3.21 0 00-3.207-3.207zm-.211 4.784a.176.176 0 01-.246 0l-1.543-1.555a.173.173 0 010-.245l.369-.369a.176.176 0 01.246 0l1.053 1.061 2.045-2.044a.174.174 0 01.246 0l.367.367a.176.176 0 010 .248l-2.537 2.537z"></path>
      </g>
    </svg>
  );
}

export function IconImport(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 502 502"
      version="1.1"
      viewBox="0 0 502 502"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M81.5 174H247c5.523 0 10-4.477 10-10s-4.477-10-10-10H81.5c-5.523 0-10 4.477-10 10s4.477 10 10 10zM306.5 220h-225c-5.523 0-10 4.477-10 10s4.477 10 10 10h225c5.523 0 10-4.477 10-10s-4.477-10-10-10zM306.5 286h-225c-5.523 0-10 4.477-10 10s4.477 10 10 10h225c5.523 0 10-4.477 10-10s-4.477-10-10-10zM306.5 352h-225c-5.523 0-10 4.477-10 10s4.477 10 10 10h225c5.523 0 10-4.477 10-10s-4.477-10-10-10zM306.5 154h-22c-5.523 0-10 4.477-10 10s4.477 10 10 10h22c5.523 0 10-4.477 10-10s-4.477-10-10-10z"></path>
      <path d="M481 379.417h-47.713A4.292 4.292 0 01429 375.13v-9.98a24.214 24.214 0 00-14.993-22.438 24.216 24.216 0 00-26.468 5.265L377 358.516V103c0-2.652-1.054-5.196-2.929-7.071l-93-93A10.001 10.001 0 00274 0H21c-5.523 0-10 4.477-10 10v482c0 5.523 4.477 10 10 10h346c5.523 0 10-4.477 10-10v-7.681l10.539 10.539a24.222 24.222 0 0026.468 5.264A24.216 24.216 0 00429 477.684v-9.98a4.292 4.292 0 014.287-4.287H481c5.523 0 10-4.477 10-10v-64c0-5.523-4.477-10-10-10zM284 34.142L342.858 93H284V34.142zM357 482H31V20h233v83c0 5.523 4.477 10 10 10h83v265.516l-35.831 35.83a10.005 10.005 0 00-2.929 7.071c0 2.652 1.054 5.196 2.929 7.071L357 464.319V482zm114-38.583h-37.713c-13.392 0-24.287 10.895-24.287 24.287v9.98c0 2.493-1.658 3.551-2.646 3.961-.99.409-2.911.833-4.672-.93l-59.299-59.298 59.298-59.298c1.763-1.762 3.684-1.338 4.672-.929.988.409 2.646 1.468 2.646 3.96v9.98c0 13.392 10.895 24.287 24.287 24.287H471v44z"></path>
    </svg>
  );
}

export function Manager(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297" {...props}>
      <path d="M148.51 117.216c32.317 0 58.608-26.291 58.608-58.608S180.827 0 148.51 0c-32.317 0-58.608 26.291-58.608 58.608s26.291 58.608 58.608 58.608zM227.154 145.618c-.025-.008-.073-.026-.098-.032-7.631-1.864-30.999-5.133-30.999-5.133a5.194 5.194 0 00-6.406 3.188l-35.174 96.509c-2.029 5.567-9.903 5.567-11.932 0l-35.174-96.509a5.195 5.195 0 00-4.876-3.42c-.504 0-24.531 3.369-32.53 5.358-21.858 5.435-35.645 26.929-35.645 49.329v80.302c0 12.034 9.756 21.79 21.79 21.79h184.782c12.034 0 21.79-9.756 21.79-21.79v-80.569c-.001-22.303-14.328-42.096-35.528-49.023z"></path>
      <path d="M161.775 138.613c-1.404-1.53-3.456-2.299-5.532-2.299h-15.485c-2.076 0-4.129.77-5.532 2.299a7.183 7.183 0 00-.946 8.462l8.278 12.479-3.875 32.69 7.631 20.3c.744 2.042 3.631 2.042 4.375 0l7.631-20.3-3.875-32.69 8.278-12.479a7.186 7.186 0 00-.948-8.462z"></path>
    </svg>
  );
}

export function Search(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
  );
}

export function Send(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
  );
}

export function Settings(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="932.179"
      height="932.179"
      x="0"
      y="0"
      enableBackground="new 0 0 932.179 932.179"
      version="1.1"
      viewBox="0 0 932.179 932.179"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M61.2 341.538c4.9 16.8 11.7 33 20.3 48.2l-24.5 30.9c-8 10.1-7.1 24.5 1.9 33.6l42.2 42.2c9.1 9.1 23.5 9.899 33.6 1.899l30.7-24.3a223.05 223.05 0 0050.1 21.2l4.6 39.5c1.5 12.8 12.3 22.4 25.1 22.4h59.7c12.8 0 23.6-9.601 25.1-22.4l4.4-38.1c18.8-4.9 36.8-12.2 53.7-21.7l29.7 23.5c10.1 8 24.5 7.1 33.6-1.9l42.2-42.2c9.1-9.1 9.9-23.5 1.9-33.6l-23.1-29.3c9.6-16.601 17.1-34.3 22.1-52.8l35.6-4.1c12.801-1.5 22.4-12.3 22.4-25.1v-59.7c0-12.8-9.6-23.6-22.4-25.1l-35.1-4.1c-4.801-18.3-12-35.8-21.199-52.2l21.6-27.3c8-10.1 7.1-24.5-1.9-33.6l-42.1-42.1c-9.1-9.1-23.5-9.9-33.6-1.9l-26.5 21c-17.2-10.1-35.601-17.8-54.9-23l-4-34.3c-1.5-12.8-12.3-22.4-25.1-22.4h-59.7c-12.8 0-23.6 9.6-25.1 22.4l-4 34.3c-19.8 5.3-38.7 13.3-56.3 23.8l-27.5-21.8c-10.1-8-24.5-7.1-33.6 1.9l-42.2 42.2c-9.1 9.1-9.9 23.5-1.9 33.6l23 29.1c-9.2 16.6-16.2 34.3-20.8 52.7l-36.8 4.2c-12.8 1.5-22.4 12.3-22.4 25.1v59.7c0 12.8 9.6 23.6 22.4 25.1l38.799 4.501zm216.3-161.5c54.4 0 98.7 44.3 98.7 98.7s-44.3 98.7-98.7 98.7c-54.399 0-98.7-44.3-98.7-98.7s44.3-98.7 98.7-98.7z"></path>
      <path d="M867.699 356.238l-31.5-26.6c-9.699-8.2-24-7.8-33.199.9l-17.4 16.3c-14.699-7.1-30.299-12.1-46.4-15l-4.898-24c-2.5-12.4-14-21-26.602-20l-41.1 3.5c-12.6 1.1-22.5 11.4-22.9 24.1l-.799 24.4c-15.801 5.7-30.701 13.5-44.301 23.3l-20.799-13.8c-10.602-7-24.701-5-32.9 4.7l-26.6 31.7c-8.201 9.7-7.801 24 .898 33.2l18.201 19.399a186.39 186.39 0 00-13.4 44.4l-26 5.3c-12.4 2.5-21 14-20 26.601l3.5 41.1c1.1 12.6 11.4 22.5 24.1 22.9l28.1.899c5.102 13.4 11.801 26.101 19.9 38l-15.699 23.7c-7 10.6-5 24.7 4.699 32.9l31.5 26.6c9.701 8.2 24 7.8 33.201-.9l20.6-19.3c13.5 6.3 27.699 11 42.299 13.8l5.701 28.2c2.5 12.4 14 21 26.6 20l41.1-3.5c12.6-1.1 22.5-11.399 22.9-24.1l.9-27.601c15-5.3 29.199-12.5 42.299-21.399l22.701 15c10.6 7 24.699 5 32.9-4.7l26.6-31.5c8.199-9.7 7.799-24-.9-33.2L872.7 592.138c6.701-14.2 11.602-29.2 14.4-44.601l25-5.1c12.4-2.5 21-14 20-26.601l-3.5-41.1c-1.1-12.6-11.4-22.5-24.1-22.9l-25.1-.8a181.601 181.601 0 00-20.9-41.2l13.699-20.6c7.201-10.598 5.201-24.798-4.5-32.998zM712.801 593.837c-44.4 3.801-83.602-29.3-87.301-73.699-3.801-44.4 29.301-83.601 73.699-87.301 44.4-3.8 83.602 29.301 87.301 73.7 3.801 44.401-29.301 83.601-73.699 87.3zM205 704.438c-12.6 1.3-22.3 11.899-22.4 24.6l-.3 25.3c-.2 12.7 9.2 23.5 21.8 25.101l18.6 2.399c3.1 11.301 7.5 22.101 13.2 32.301l-12 14.8c-8 9.899-7.4 24.1 1.5 33.2l17.7 18.1c8.9 9.1 23.1 10.1 33.2 2.3l14.899-11.5c10.5 6.2 21.601 11.101 33.2 14.5l2 19.2c1.3 12.6 11.9 22.3 24.6 22.4l25.301.3c12.699.2 23.5-9.2 25.1-21.8l2.3-18.2c12.601-3.101 24.601-7.8 36-14l14 11.3c9.9 8 24.101 7.4 33.201-1.5l18.1-17.7c9.1-8.899 10.1-23.1 2.301-33.2L496.6 818.438c6.6-11 11.701-22.7 15.201-35l16.6-1.7c12.6-1.3 22.299-11.9 22.4-24.6l.299-25.301c.201-12.699-9.199-23.5-21.799-25.1l-16.201-2.1c-3.1-12.2-7.699-24-13.699-35l10.1-12.4c8-9.9 7.4-24.1-1.5-33.2l-17.699-18.1a24.966 24.966 0 00-33.201-2.3l-12.101 9.3a147.09 147.09 0 00-36.399-15.8l-1.601-15.7c-1.3-12.601-11.899-22.3-24.6-22.4l-25.3-.3c-12.7-.2-23.5 9.2-25.101 21.8l-2 15.601a151.042 151.042 0 00-37.699 15.399l-12.5-10.2c-9.9-8-24.101-7.399-33.201 1.5l-18.2 17.801a24.965 24.965 0 00-2.3 33.199l10.7 13.801c-6.2 11-11.1 22.699-14.3 35l-17.499 1.8zm163.3-28.601c36.3.4 65.399 30.301 65 66.601-.4 36.3-30.301 65.399-66.601 65-36.3-.4-65.399-30.3-65-66.601.401-36.299 30.301-65.399 66.601-65z"></path>
    </svg>
  );
}

export function User(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 55 55"
      version="1.1"
      viewBox="0 0 55 55"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M55 27.5C55 12.337 42.663 0 27.5 0S0 12.337 0 27.5c0 8.009 3.444 15.228 8.926 20.258l-.026.023.892.752c.058.049.121.089.179.137.474.393.965.766 1.465 1.127.162.117.324.234.489.348.534.368 1.082.717 1.642 1.048.122.072.245.142.368.212a27.44 27.44 0 001.88.98l.142.064a27.252 27.252 0 006.651 2.105l.184.033c.724.125 1.456.225 2.197.292.09.008.18.013.271.021.738.061 1.484.1 2.24.1.749 0 1.488-.039 2.222-.098l.279-.021a27.808 27.808 0 002.178-.287l.187-.034a27.251 27.251 0 006.557-2.055c.076-.035.153-.068.229-.104a27.639 27.639 0 002.25-1.189 27.514 27.514 0 001.581-1c.185-.126.366-.259.549-.391.439-.316.87-.642 1.289-.983.093-.075.193-.14.284-.217l.915-.764-.027-.023C51.523 42.802 55 35.55 55 27.5zm-53 0C2 13.439 13.439 2 27.5 2S53 13.439 53 27.5c0 7.577-3.325 14.389-8.589 19.063a7.494 7.494 0 00-.893-.537l-8.467-4.233a2.217 2.217 0 01-1.232-1.993v-2.957c.196-.242.403-.516.617-.817a20.378 20.378 0 002.616-5.123 3.63 3.63 0 002.085-3.289v-3.545c0-.867-.318-1.708-.887-2.369v-4.667c.052-.52.236-3.448-1.883-5.864C34.524 9.065 31.541 8 27.5 8s-7.024 1.065-8.867 3.168c-2.119 2.416-1.935 5.346-1.883 5.864v4.667a3.644 3.644 0 00-.887 2.369v3.545c0 1.101.494 2.128 1.34 2.821.81 3.173 2.477 5.575 3.093 6.389v2.894a2.23 2.23 0 01-1.162 1.958l-7.907 4.313a7.227 7.227 0 00-.752.476C5.276 41.792 2 35.022 2 27.5z"></path>
    </svg>
  );
}

export function Download(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"></path>
      <path fill="none" d="M0 0h24v24H0z"></path>
    </svg>
  );
}

export function Compliance(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
      viewBox="0 0 64 64"
      {...props}
    >
      <path d="M63 5V3c0-1.103-.897-2-2-2H3c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v38c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h18.612l-4 12h8.108l4-12h4.558l4 12h8.108l-4-12H61c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2V7c1.103 0 2-.897 2-2zM3 3h58l.001 2H3zm2 24h4v14H5zm19.279 34h-3.892l3.334-10h3.892zm19.334 0h-3.892l-3.333-10h3.892zm17.388-12H3v-2h58zM59 45H5v-2h6v-2h.838l1.922.641a6.99 6.99 0 002.214.359H30a2.996 2.996 0 002.954-2.545l.211-.109c.709.362 1.455.67 2.229.919L36.271 43h7.459l.876-2.734c.774-.249 1.52-.557 2.229-.919l2.548 1.311 5.274-5.273-1.312-2.549c.363-.709.67-1.455.919-2.229L57 29.729V22.27l-2.734-.876a14.935 14.935 0 00-.919-2.229l1.312-2.549-5.274-5.274-2.549 1.312a15.016 15.016 0 00-2.229-.919L43.729 9H36.27l-.876 2.734c-.774.249-1.52.557-2.229.919l-2.549-1.312-5.274 5.274 1.312 2.549a15.064 15.064 0 00-.925 2.247l-1.729.61V16c0-2.206-1.794-4-4-4-1.103 0-2 .897-2 2v5.395a7.588 7.588 0 01-3.387 6.328A7.562 7.562 0 0111 26.956V25H5V7h54zM11 28.956c1.685-.106 3.309-.626 4.723-1.569A9.585 9.585 0 0020 19.395V14c1.103 0 2 .897 2 2v7c0 1.654 1.346 3 3 3h5a1.001 1.001 0 010 2h-3v2h3a1.001 1.001 0 010 2h-3v2h3a1.001 1.001 0 010 2h-3v2h3a1.001 1.001 0 010 2H15.974c-.54 0-1.071-.086-1.581-.256L12.162 39H11zm16.788-11.957l3.211-3.212 2.195 1.13.468-.263a13.01 13.01 0 012.796-1.152l.517-.146.754-2.356h4.541l.755 2.356.517.146c.989.28 1.929.668 2.796 1.152l.468.263 2.195-1.13 3.211 3.212-1.129 2.194.262.469c.487.87.875 1.811 1.153 2.797l.146.517 2.356.753v4.541l-2.356.754-.146.517a12.84 12.84 0 01-1.153 2.796l-.263.469 1.13 2.195-3.211 3.211-2.195-1.129-.468.263a13.01 13.01 0 01-2.796 1.152l-.517.146L42.271 41H37.73l-.755-2.356-.517-.146a13.01 13.01 0 01-2.796-1.152l-.468-.263-.655.337a3.042 3.042 0 00-.32-.42c.48-.532.78-1.229.78-2 0-.198-.022-.39-.058-.578A11.016 11.016 0 0040 37c6.065 0 11-4.935 11-11s-4.935-11-11-11a10.95 10.95 0 00-10.813 9H25a.976.976 0 01-.379-.077l2.74-.966.141-.498c.278-.986.667-1.927 1.153-2.797l.262-.469zm3.384 7.24A8.962 8.962 0 0140 17c4.962 0 9 4.037 9 9s-4.038 9-9 9a9.012 9.012 0 01-7.057-3.439c.035-.182.057-.369.057-.561a2.98 2.98 0 00-.78-2c.48-.532.78-1.229.78-2a3.004 3.004 0 00-1.828-2.761z"></path>
      <path d="M40 33c3.86 0 7-3.141 7-7s-3.14-7-7-7-7 3.141-7 7 3.14 7 7 7zm0-12c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zM7 9h9v2H7zM7 13h9v2H7zM7 17h9v2H7z"></path>
    </svg>
  );
}